import React from 'react';
import DescribeManualMealContainer from './DescribeManualMealContainer';
import { useLocation } from 'react-router-dom';

const DescribeManualMealPage: React.FC<{ fromUserMeals?: boolean }> = ({ fromUserMeals }) => {
  const location = useLocation();

  return <DescribeManualMealContainer key={location.key} fromUserMeals={fromUserMeals} />;
};

export default DescribeManualMealPage;
